import { Tier } from 'features/premium/entities';
const APP_ICONS = [
    // seasonal
    {
        name: 'christmas',
        assetName: 'christmas',
    },
    // regular
    {
        assetName: 'normal',
        name: 'normal',
    },
    {
        assetName: 'pride',
        name: 'pride',
    },
    {
        assetName: 'black',
        name: 'black',
    },
    {
        assetName: 'slavaukraini',
        name: 'slavaukraini',
    },
    {
        assetName: 'blackculture',
        name: 'blackculture',
    },
    {
        assetName: 'gold',
        name: 'plus',
        tier: Tier.plus,
    },
    {
        assetName: 'green',
        name: 'pro',
        tier: Tier.pro,
    },
    {
        assetName: 'purple',
        name: 'ultimate',
        tier: Tier.ultimate,
    },
    {
        name: 'investor',
        assetName: 'investor',
    },
];
export const CHRISTMAS_APP_ICON = APP_ICONS.find((icon) => icon.name === 'christmas');
export const DEFAULT_APP_ICON = APP_ICONS.find((icon) => icon.name === 'normal');
export const iconStrings = {
    normal: 'Standard',
    pride: 'Pride',
    black: 'Black',
    plus: 'Plus',
    pro: 'Pro',
    ultimate: 'Ultimate',
    slavaukraini: 'Slava Ukraini!',
    blackculture: 'Black culture',
    investor: 'Investor',
    christmas: 'Christmas',
};
export const getAppIconByAssetName = (assetName) => APP_ICONS.find((icon) => icon.assetName === assetName);
export default APP_ICONS;
